import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '@env/environment';
import {ConstantsService} from '@app/services/constants/constants.service';

@Injectable({
    providedIn: 'root'
})
export class ActivityService {

    apiUrl = environment.apiURL;
    dailyActivities = [];

    constructor(private httpClient: HttpClient,
                private constantsService: ConstantsService) {
    }

    sendDailyActivitiesToProventumInstance() {
        const params = new HttpParams()
            .set('data', JSON.stringify(this.dailyActivities))
            .set('user_id', this.constantsService.creator_id);
        return this.httpClient.post(this.apiUrl + '/proventum-connector/sendActivitiesToProventum', params);

    }

    setActivities(data) {
        this.dailyActivities = data;
    }


    getActivities(date: string) {
        const params = new HttpParams()
            .set('creator', this.constantsService.creator_id)
            .set('date', date);
        return this.httpClient.get<any>(this.apiUrl + '/task/getActivities', {params: params});
    }
  getSatnica(date: string) {
    const params = new HttpParams()
      .set('creator', this.constantsService.creator_id)
      .set('date', date);
    return this.httpClient.get<any>(this.apiUrl + '/task/satnica', {params: params});
  }
  getActivitiesDataRange(start:string, end:string)
  {
    const params = new HttpParams()
      .set('creator', this.constantsService.creator_id)
      .set('start', start)
      .set('end', end)
    return this.httpClient.get<any>(this.apiUrl + '/task/getActivitiesRangeData', {params: params});
  }

    getDetailsAutomaticActiviry(taskId, projectId) {
        const params = new HttpParams()
            .set('project_id', projectId)
            .set('task_id', taskId);
        return this.httpClient.get<any>(this.apiUrl + '/task/getTaskDataAndProjectData', {params: params});
    }

    // nakon slanja aktivnosti u proventum, potrebno je setovati njihov status na inactive u task manager
    setActivitiesInactive(data) {
        const params = new HttpParams()
            .set('data', data);
        return this.httpClient.post(this.apiUrl + '/activities/setActivitiesInactive', params);
    }

    addActivity(activityObject, mode) {

        const params = new HttpParams()
            .set('creator', this.constantsService.creator_id)
            .set('mode', mode)
            .set('activityObject', JSON.stringify(activityObject));
        const headers = new HttpHeaders({
          'Authorization': 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyZW1lbWJlck1lIjpudWxsLCJzdWIiOjEwMiwiaXNzIjoiaHR0cHM6Ly9maW5hbmNlcGx1cy5wcm92ZW50dW0ubWUvYXBpL2F1dGhlbnRpY2F0ZSIsImlhdCI6MTY2NjM0MjY3NywiZXhwIjoxNjY4OTM4Mjc3LCJuYmYiOjE2NjYzNDI2NzcsImp0aSI6IkZ3Y1hqbk05SnNSc0U1OGYifQ.juSmCCdf6vUbJbYrdbidupTD0SIXtgFqbP_Pk1ZNvNI'
        });
        return this.httpClient.post(this.apiUrl + '/activities/addActivity', params,{
          headers,
          params
        });
    }


}
